import { render, staticRenderFns } from "./PositionCard.vue?vue&type=template&id=7f051e12&scoped=true"
import script from "./PositionCard.js?vue&type=script&lang=js&external"
export * from "./PositionCard.js?vue&type=script&lang=js&external"
import style0 from "./PositionCard.scss?vue&type=style&index=0&id=7f051e12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f051e12",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotHcmImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/HcmImage/index.vue').default,HotHcmCard: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmCard/index.vue').default})
